import type { Vec2, Vec3 } from '../../geo/types';

/*
 * A beam, a post or a rail is one timber, so its v stays mid-course: the painted wood pattern draws a
 * plank joint every 0.15 of v (painted.frag, SURFACE_WOOD), and none falls at 0.075.
 */
export const TIMBER_V = 0.075;

/** Uvs for a quad on one timber: u runs along local x in metres, v stays mid-course. */
export function timberUv(
  corners: readonly [Vec3, Vec3, Vec3, Vec3]
): readonly [Vec2, Vec2, Vec2, Vec2] {
  return [
    [corners[0][0], TIMBER_V],
    [corners[1][0], TIMBER_V],
    [corners[2][0], TIMBER_V],
    [corners[3][0], TIMBER_V],
  ];
}
